import { helpers } from "vuelidate/lib/validators";

const fileSizeMax = param =>
  helpers.withParams(
    { type: "fileSizeMax", value: param },
    value => !value || value.size <= param
  );

export default fileSizeMax;
